import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { m } from "@vega-core/paraglide/messages";

import type { FileConflict } from "./utils/dropUtils";

type ReplaceFilesModalProps = {
  open: boolean;
  conflicts: FileConflict[];
  onReplace: () => void;
  onKeepBoth: () => void;
  onCancel: () => void;
};

export function ReplaceFilesModal({
  open,
  conflicts,
  onReplace,
  onKeepBoth,
  onCancel,
}: ReplaceFilesModalProps) {
  return (
    <ActionaryModal
      ModalButtonsGroupProps={{
        mainAction: onReplace,
        mainActionText: m.coInvestments_dataRoom_replaceFiles_replace(),
        secondaryAction: onKeepBoth,
        secondaryActionText: m.coInvestments_dataRoom_replaceFiles_keepBoth(),
        thirdActionElement: (
          <ThemedButton
            dataTestId="replace-files-cancel-button"
            onClick={onCancel}
            variant="text"
          >
            {m.common_cancel()}
          </ThemedButton>
        ),
      }}
      dataTestId="replace-files-modal"
      defaultWidth
      fluidHeight
      open={open}
      setOpen={(val) => {
        if (!val) onCancel();
      }}
      title={m.coInvestments_dataRoom_replaceFiles_title()}
    >
      <div className="flex flex-col gap-3 px-4 py-3">
        <p className="body-base-regular text-text/secondary">
          {m.coInvestments_dataRoom_replaceFiles_description({
            count: conflicts.length,
          })}
        </p>
        <ul className="flex flex-col gap-1">
          {conflicts.map((conflict) => (
            <li
              className="body-small-regular truncate text-text/primary"
              data-testid={`replace-files-conflict-${conflict.existingNodeId}`}
              key={conflict.existingNodeId}
              title={conflict.fullPath}
            >
              {conflict.fullPath}
            </li>
          ))}
        </ul>
      </div>
    </ActionaryModal>
  );
}
